import React from "react";
import CommonStatePage from "./CommonStatePage";

const AccessDeniedPage = () => {
  return (
    <CommonStatePage
      type="accessDenied"
      code="403"
      title="Access Denied"
      description="You do not have permission to access this page. Please contact the administrator or return to your bookings."
      primaryButtonText="Go to Bookings"
      primaryButtonPath="/bookings"
    />
  );
};

export default AccessDeniedPage;
